<template>
  <div v-if="!loading" class="pc-mode">
    <div id="header">
      <div class="container">
        <a id="logo" href="https://www.westjr.co.jp/" target="_blank">
        <img src="../../assets/images/jr_logo_title.svg" alt="JR西日本旅客鉄道株式会社" width="350" class="logo-svg">
        </a>
        <a class="text-center pdf-btn" target="_blank" :href="baseUrl + this.pdfPath" @click="onPDF()">PDF出力</a>
        <div id="print-btn" @click="onPrint()">印刷</div>
      </div>
    </div>
    <div class="container">
      <article>
        <h1>遅延証明書</h1>
        <div class="contents">
          <div class="line-info">
            <h4 v-if="line">
              <span>
                <i v-if="line.line_color_1" :style="{ border: 'solid 4px ' + line.line_color_1,'background-color': line.line_color_1 }"></i><i v-if="line.line_color_2"  :style="{ border: 'solid 4px ' + line.line_color_2, 'background-color': line.line_color_2 }"></i><i v-if="line.line_color_3" :style="{ border: 'solid 4px ' + line.line_color_3, 'background-color': line.line_color_3 }"></i>
              </span>
              {{ line.line_name }}<template v-if="line.section_name">({{ line.section_name }})</template>
            </h4>
            <h5 v-if="isToday">{{ targetDate | jpYYYYMMDDdd }}</h5>
            <h5 v-else-if="isHistory">{{ targetDate | jpYYYYMMDDdd }}</h5>
          </div>
          <p v-if="line && timeZone">{{ line.line_name }}<template v-if="line.section_name">({{ line.section_name }})</template>の列車が{{ timeZone.display_name }}の間、最大で以下の通り遅れたことを証明します。</p>
          <p>ご迷惑をおかけし、誠に申し訳ございませんでした。</p>
          <div id="delayTime">
            <div>
              <div>{{ delayCertificateNum }}<span class="line-timezone-delay-data-text">{{ delayCertificateText }}</span></div>
            </div>
          </div>
          <ul>
            <li>本証明書は、その路線で発生した最大の遅延時分を証明するものであり、個々の列車の遅延時分を証明するものではありません。また、お客様がご乗車されたことを証明するものではありません。</li>
            <li>本証明書は、JR線の遅延のみを証明するものであり、遅延によりお客様に生じた損害等を賠償することを証明するものではありません。</li>
            <li>本証明書は、JR線の一部の駅で発行している遅延証明書と遅延時分が異なることがあります。</li>
            <li>本証明書を無断で転載、複写すること、また、体裁を変更するなどしてホームページ等で公開することを固く禁じます。</li>
          </ul>
        </div>
        <p class="footer">{{ today | jpYYYYMMDDdd}}</p>
        <p class="footer"><img style="width: 150px;" src="../../assets/images/jr-name-logo.svg"/></p>
      </article>
      <div id="comment">※ 「印刷」「PDF出力」ボタンをクリックして、プリントアウトおよびPDFファイルをダウンロードしてください。</div>
      <div id="print_comment">Copyright © WEST JAPAN RAILWAY COMPANY all rights reserved. このサイトに掲載されている情報はJR西日本が提供しております。</div>
    </div>
    <div class="dark">
      <div class="container">
        Copyright © WEST JAPAN RAILWAY COMPANY all rights reserved. このサイトに掲載されている情報はJR西日本が提供しております。
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from 'configs'
var moment = require('moment')
export default {
  name: 'DelayCertificate',
  data () {
    const targetDate = this.$route.params.targetDate
    const today = moment()
    const isToday = this.$route.params.today === 'today'
    const isHistory = this.$route.params.today === 'history'
    const areaId = parseInt(this.$route.params.areaId, 10)
    const lineId = parseInt(this.$route.params.lineId, 10)
    const timeZoneId = parseInt(this.$route.params.timeZoneId, 10)
    const baseUrl = config.api.base
    let pdfPath
    if (isToday) {
      pdfPath = '/today/pdf/' + areaId + '/' + lineId + '/' + timeZoneId
    } else {
      pdfPath = '/history/pdf/' + areaId + '/' + lineId + '/' + targetDate + '/' + timeZoneId
    }
    return {
      today,
      isToday,
      isHistory,
      pdfPath,
      areaId,
      lineId,
      timeZoneId,
      targetDate,
      baseUrl,
      area: undefined,
      line: undefined,
      timeZone: undefined,
      delayCertificate: '',
      delayCertificateNum: '',
      delayCertificateText: ''
    }
  },
  methods: {
    isNum (num) {
      return num !== undefined && /^\d+$/.test(num) === true
    },
    onPrint () {
      window.print()
    },
    onPDF () {
      this.$gtag.event('click', {
        'event_category': 'pdf',
        'event_label': this.pdfPath,
        'value': 1
      })
    },
    init () {
      if (this.areaStatus !== 'init' || this.timeZoneStatus !== 'init') {
        return
      }
      this.area = this.areas.find(area => area.area_id === this.areaId)
      if (this.area === undefined) {
        this.$router.push({path: '/404'})
        return
      }
      this.line = this.area.lines.find(line => line.line_id === this.lineId)
      if (this.line === undefined) {
        this.$router.push({path: '/404'})
        return
      }
      this.timeZone = this.timeZones.find(timeZone => timeZone.time_zone_id === this.timeZoneId)
      if (this.timeZone === undefined) {
        this.$router.push({path: '/404'})
        return
      }
      if (this.isToday) {
        this.$store.commit('delaycertificatetoday/setStatus', '')
        this.$store.dispatch('delaycertificatetoday/all', [this.areas, this.timeZones])
        const unwatchDelayCertificateToday = this.$store.watch(
          (state) => state.delaycertificatetoday.status,
          (value) => {
            if (value === 'init') {
              unwatchDelayCertificateToday()
              try {
                this.targetDate = moment(this.todayDelays.created_at).hour() < 3 ? moment(this.todayDelays.created_at).subtract(1, 'days') : this.todayDelays.created_at
                const lines = this.todayDelays.areas.find((area) => area.area_id === this.areaId).lines
                const line = lines.find((line) => line.line_id === this.lineId)
                const timeZonesDelay = line.delay_certificates
                const cert = timeZonesDelay.find((item) => item.time_zone_id === this.timeZoneId)
                if (cert.delay_certificate_item_type === 'DELAY_CERTIFICATE') {
                  // 遅延証明書表示
                  this.delayCertificate = cert.delay_certificate
                  this.delayCertificateNum = this.delayCertificate.replace(/[^0-9]/g, '')
                  this.delayCertificateText = this.delayCertificate.replace(/[0-9]/g, '')
                  this.$store.commit('loading/setStatus', false)
                  return
                }
              } catch (err) {
              }
              this.$router.push({path: '/404'})
            }
          }
        )
      } else if (this.isHistory) {
        this.$store.commit('history/setStatus', '')
        this.$store.dispatch('history/all', [this.lineId, this.timeZones])
        const unwatchHistory = this.$store.watch(
          (state) => state.history.status,
          (value) => {
            if (value === 'init') {
              unwatchHistory()
              try {
                const dateDelay = this.historys.find(item => item.date === this.targetDate)
                const cert = dateDelay.data.find((item) => item.time_zone_id === this.timeZoneId)
                if (cert.delay_certificate_item_type === 'DELAY_CERTIFICATE') {
                  this.delayCertificate = cert.delay_certificate
                  this.delayCertificateNum = this.delayCertificate.replace(/[^0-9]/g, '')
                  this.delayCertificateText = this.delayCertificate.replace(/[0-9]/g, '')
                  this.$store.commit('loading/setStatus', false)
                  return
                }
              } catch (err) {
              }
              this.$router.push({path: '/404'})
            }
          }
        )
      } else {
        this.$router.push({path: '/404'})
      }
    }
  },
  created () {
    if (!this.isNum(this.$route.params.areaId) ||
      !this.isNum(this.$route.params.lineId) ||
      !this.isNum(this.$route.params.timeZoneId)) {
      this.$router.push({path: '/404'})
      return
    }
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    const unwatchAreaLine = this.$store.watch(
      (state) => state.areaLine.status,
      (value) => {
        if (value === 'init') {
          unwatchAreaLine()
          this.init()
        }
      }
    )
    const unwatchTimeZone = this.$store.watch(
      (state) => state.timeZone.status,
      (value) => {
        if (value === 'init') {
          unwatchTimeZone()
          this.init()
        }
      }
    )
  },
  computed: {
    ...mapState('areaLine', {
      areas: state => state.areas,
      areaStatus: state => state.status
    }),
    ...mapState('timeZone', {
      timeZones: state => state.timeZones,
      timeZoneStatus: state => state.status
    }),
    ...mapState('delaycertificatetoday', {
      todayDelays: state => state.todayDelays,
      todayStatus: state => state.status
    }),
    ...mapState('history', {
      historys: state => state.historys,
      historyStatus: state => state.status
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.line-timezone-delay-data-text {
    font-size: 26px !important;
    margin-left: 4px;
}
#print-btn {
  float: right;
  margin: 23px 10px 23px 0;
  width: 160px;
  height: 44px;
  border-radius: 0;
  border: solid 1px #ccc;
  background-color: white;
  color: black;
  cursor: pointer;
  text-align: center;
  padding-top: 12px;
  font-size: 16px;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.4);
}
.pdf-btn {
  float: right;
  text-decoration: none;
  margin: 23px 0 ;
  width: 160px;
  line-height: 43px;
  font-size: 16px;
  border-radius: 0;
  border: solid 1px #ccc;
  background-color: white;
  color: black;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.4);
}
#logo {
  margin-top: 27px;
  background-color: #FFFFFF;
  img {
    margin: 27px 0;
  }
}
#header {
  height: 90px;
  border-bottom: solid 1px #ccc;
  min-width: 970px;
  .title {
    color: $primary;
    font-size: 2rem;
  }
}
article {
  border: solid 2px #3070B3;
  margin: 50px 60px 0 50px;
  padding: 25px 40px;
  h1 {
    padding: 0;
    margin: 0;
    font-size: 28px;
    font-weight: 600;
  }
  div.contents {
    margin-top: 26px;
    margin-bottom: 26px;
    border-bottom: dotted 1px #3070b3;
    border-top: dotted 1px #3070b3;
    div.line-info {
      margin: 38px 0;
      h4 {
        font-size: 24px;
        font-weight: 600;
        span {
          vertical-align: middle;
          margin-right: -8px;
          i {
              width: 8px;
              margin-right: 1px;
              margin-top: 2px;
              border-radius: 4px;
              height: 22px;
              display: inline-block;
              content: "&nbsp;";
            -webkit-print-color-adjust: exact;
          }
        }
      }
      h5 {
        font-size: 18px;
        font-weight: 600;
      }
    }
    ul {
      padding-left: 12px;
      margin-bottom: 30px;
      list-style: none;
      li {
        &:before {
          margin-left: -13px;
          display: inline-block;
          font-weight:bold;
          content: '・';
          color: #3070b3;
        }
      }
    }
    p {
      text-align: left;
    }
  }
  p {
    margin-bottom: 0;
    text-align: right;
    &.footer {
      font-weight: bold;
    }
  }
  #delayTime {
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: auto;
    margin-right: auto;
    height: 70px;
    width: 280px;
    text-align: center;
    color: #e02d2d;
    border: solid 4px #e02d2d;
    padding: 3px;
    font-weight: 600;
    div {
      div {
        font-size: 40px;
        padding-top: 8px;
        border: solid 2px #e02d2d;
        line-height: 40px;
      }
    }
  }
}
#comment {
  margin-top: 17px;
  margin-bottom: 58px;
  padding-left: 50px;
}
#print_comment {
  display: none;
}
.dark {
  min-width: 970px;
  background-color: $footer-dark-back;
  height: 80px;
  color: white;
  padding-top: 30px;
}

body {
  .logo-png {
      display: none;
    }
    .logo-svg {
      display: inline;
    }
  &.ie11 {
    @media print {
      .logo-png {
        display: inline !important;
      }
      .logo-svg {
        display: none !important;
      }
    }
  }
}
@media print {
  #print-btn {
    display: none;
  }
  .pdf-btn {
    display: none;
  }
  .dark {
    display: none;
  }
  #comment {
    display: none;
  }
  #print_comment {
    margin-top: 17px;
    padding-left: 0px;
    display: block;
    font-size: 11px;
  }
  #app {
    .pc-mode {
      #header {
        min-width: unset !important;
      }
      .container {
        width: 640px !important;
        min-width: 640px !important;
        max-width: 640px !important;
      }

      article {
        margin: 20px 0 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/DelayCertificate.vue